import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SyncStatusIndicator from './SyncStatusIndicator';
import { LanguageSelector } from './LanguageSelector';
import { ThemeToggleButton } from './ThemeToggleButton';
import { Bars3Icon } from '@heroicons/react/24/outline';
import { NavigationItems } from './NavigationItems';
import { MobileMenu } from './MobileMenu';
import { CreateBudgetActions } from './CreateBudgetActions';

export const Navigation: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <>
      <nav className="bg-white shadow dark:bg-gray-800">
        <div className="mx-auto max-w-7xl px-2 sm:px-4 lg:px-8">
          <div className="flex h-16 justify-between">
            <div className="flex items-center">
              <div className="flex flex-shrink-0 items-center">
                <Link
                  to="/landing"
                  className="flex items-center text-xl font-bold text-gray-800 dark:text-white"
                >
                  <img src="/logo.svg" alt="FairBalance Logo" className="h-8 w-8" />
                  <span className="ml-2 hidden sm:inline">FairBalance</span>
                </Link>
              </div>
              <div className="ml-4 hidden md:flex lg:ml-6">
                <NavigationItems showLabels={true} className="space-x-2 lg:space-x-4" />
              </div>
            </div>
            <div className="flex items-center space-x-2 sm:space-x-3">
              <div className="flex items-center">
                <div className="hidden xl:block">
                  <CreateBudgetActions showText={true} />
                </div>
                <div className="xl:hidden">
                  <CreateBudgetActions showText={false} />
                </div>
              </div>
              <div className="hidden md:flex md:items-center md:space-x-1 lg:space-x-3">
                <div className="hidden xl:block">
                  <SyncStatusIndicator />
                </div>
                <ThemeToggleButton />
                <LanguageSelector />
              </div>
              <button
                onClick={() => setIsMobileMenuOpen(true)}
                className="rounded-md p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 dark:hover:bg-gray-700 md:ml-1 md:hidden"
              >
                <Bars3Icon className="h-6 w-6" />
              </button>
            </div>
          </div>
        </div>
      </nav>
      <MobileMenu isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} />
    </>
  );
};
